<template>
  <div class="row">
    <div class="col-md-12">
      <input type="text" class="form-control" v-model="name" />
    </div>
    <div class="col-md-12 pt-0 pb-0">
      <ErrorsMessages :errors="errors" />
    </div>
    <div class="col-md-6">
      <v-btn @click="$emit('cancel')" class="btn-cancel"
        ><i class="fas fa-times mr-2"></i>CANCELAR</v-btn
      >
    </div>
    <div class="col-md-6 text-right">
      <v-btn @click="create" class="btn-save" :disabled="loading">
        <i class="fas fa-check mr-2"></i>SALVAR</v-btn
      >
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

export default {
  name: "ModalIdCreate",

  components: { ErrorsMessages },

  props: {
    id: { type: String, required: true },
  },

  data() {
    return {
      name: "",
      loading: false,
      errors: [],
    };
  },

  methods: {
    async create() {
      try {
        this.loading = true;

        let { id: type, name } = this;

        let params = { id: type, name };

        let response = await api.post("/rest-home/financial/id-create", params);

        let { error, errors, message, id } = response.data;

        if (!error) {
          this.errors = [];
          toast(message, "success");
          this.$emit("success", { type, id });
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
